<template>
    <div>
        <h3>{{title}}</h3>
        <hr />
        <BankAccountEditor
            :bankAccount="bankAccount"
            :required="required"
            :showDescription="true"
            :readonly="readonly"
        ></BankAccountEditor>

        <div class="btn-group" v-if="allowEdit">
            <button
                v-if="!editing"
                type="button"
                class="btn btn-primary btn"
                @click.stop="openForEdit"
            >
                <i class="fas fa-edit"></i>
                {{ $t('buttons.edit.btnText') }}
            </button>
            <button
                v-if="editing"
                type="button"
                class="btn btn-primary btn"
                :class="saving ? 'disabled' : ''"
                @click.stop="createOrEdit"
            >
                <i class="fas fa-spinner fa-spin" v-if="saving"></i>
                <i class="fas fa-save" v-else></i>
                {{ $t('buttons.save.btnText') }}
            </button>
            <button
                v-if="editing"
                type="button"
                class="btn btn-danger btn"
                :class="saving ? 'disabled' : ''"
                @click.stop="cancelEdit"
            >
                <i class="fas fa-ban"></i>
                {{ $t('buttons.cancel') }}
            </button>
        </div>
    </div>
</template>

<script>
import { BankAccount } from './../../models/models';
import BankAccountEditor from './BankAccountEditor';
import personService from '../../services/person.service';

export default {
    inject: ["$validator"],
    props: {
        bankAccount: BankAccount,
        title: String,
        required: {
            type: Boolean,
            default: true,
        },
        allowEdit: {
            default: false,
            type: Boolean,
        },
        isBankAccountDetails: {
            type: Boolean,
            default: false,
        },
        userId: {
            type: String,
            default: null,
        },
    },

    components: { BankAccountEditor },
    data() {
        return {
            saving: false,
            editing: false,
            personId: null,
            oldValue: new BankAccount(),
        };
    },
    mounted: function () {
        this.bankAccount.uid = "contract" + this._uid;
        if (this.userId) {
            this.getPersonByUserId();
        }
    },
    computed: {
        isNew() {
            return !this.address || this.address.id <= 0;
        },
        readonly() {
            return this.isBankAccountDetails && !this.editing;
        },
    },
    methods: {
        openForEdit() {
            this.editing = true;
            this.oldValue = new BankAccount(this.bankAccount);
        },
        cancelEdit() {
            this.editing = false;
            this.address = this.oldValue;
        },
        getPersonByUserId() {
            personService
                .getByUserId(this.userId)
                .then((result) => {
                    if (result) {
                        this.personId = result.data.id;
                    }
                })
                .catch((error) => {});
        },
        loadBankAccount() {
            this.getPersonByUserId();
            if (this.personId) {
                personService
                    .getBankAccountById(this.personId)
                    .then((result) => {
                        if (result) {
                            this.bankAccount = new BankAccount(result.data);
                        }
                    });
            }
        },
        createOrEdit() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    if (this.userId) {
                        this.getPersonByUserId();
                        this.bankAccount.personId = this.personId;
                    }
                    this.saving = true;
                    personService
                        .addOrUpdateBankAccount(this.bankAccount)
                        .then((response) => {
                            this.saving = false;
                            this.$vs.notify({
                                title: this.$t("notifications.success"),
                                text: this.$t(
                                    "notifications.successfulSavedData"
                                ),
                                position: "top-center",
                                color: "success",
                            });
                        })
                        .catch((error) => {
                            this.saving = false;
                            this.$vs.notify({
                                title: this.$t(
                                    "request.response.status." +
                                        this.$helpers.errorStatusCode(error)
                                ),
                                text: this.$helpers.errorText(error),
                                color: this.$helpers.errorColor(error),
                                time: this.$store.getters.notificationDuration,
                            });
                        });
                }
            });
        },
    },
    watch: {
        personId(newVal) {
            if (newVal) {
                this.loadBankAccount();
            }
        },
    },
};
</script>

<style scoped>
</style>
